/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Order } from '../models/Order';
import type { OrderAttachmentModel } from '../models/OrderAttachmentModel';
import type { OrderFlagsInput } from '../models/OrderFlagsInput';
import type { OrderInput } from '../models/OrderInput';
import type { OrderOption } from '../models/OrderOption';
import type { OrdersPage } from '../models/OrdersPage';
import type { ValidationInput } from '../models/ValidationInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderService {
    /**
     * Retrieve an Order
     * Retrieve an Order
     * @param orderId
     * @returns Order The requested order object.
     * @throws ApiError
     */
    public static orderControllerGetOrder(
        orderId: string,
    ): CancelablePromise<Order> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/order/{orderID}',
            path: {
                'orderID': orderId,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * Retrieve orders from a given store.
     * Retrieve orders from a given store.
     * @param storeId
     * @param offset
     * @param limit
     * @returns OrdersPage The page of the found orders.
     * @throws ApiError
     */
    public static orderControllerGetOrders(
        storeId: string,
        offset?: number,
        limit?: number,
    ): CancelablePromise<OrdersPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/order/list/{storeID}',
            path: {
                'storeID': storeId,
            },
            query: {
                'offset': offset,
                'limit': limit,
            },
        });
    }
    /**
     * @param orderId
     * @param attachmentName
     * @returns OrderAttachmentModel
     * @throws ApiError
     */
    public static orderControllerGetOrderAttachment(
        orderId: string,
        attachmentName: string,
    ): CancelablePromise<OrderAttachmentModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/order/{orderID}/attachment/{attachmentName}',
            path: {
                'orderID': orderId,
                'attachmentName': attachmentName,
            },
        });
    }
    /**
     * Create an order.
     * Create an order.
     * @param requestBody
     * @returns Order The created order object.
     * @throws ApiError
     */
    public static orderControllerCreateOrder(
        requestBody: OrderInput,
    ): CancelablePromise<Order> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/order/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Could not create Order.`,
                404: `Company not found.`,
            },
        });
    }
    /**
     * Update the flags of an order.
     * Update the flags of an order.
     * @param requestBody
     * @returns Order The updated order object.
     * @throws ApiError
     */
    public static orderControllerOrderFlags(
        requestBody: OrderFlagsInput,
    ): CancelablePromise<Order> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/order/flags',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not found`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns OrderOption
     * @throws ApiError
     */
    public static orderControllerValidate(
        requestBody: ValidationInput,
    ): CancelablePromise<Array<OrderOption>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/order/validate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
